import { Promotion } from '@src/services/promotion/promotionApiSliceTypes';
import { chunk } from 'lodash';

import { BadgeGroup } from '../BadgeGroup';
import { Flag } from '../Flag';

interface PromotionGalleryProps {
  promotions: Promotion[];
  onPromotionClick: (countryId: string) => void;
}

export function PromotionGallery({
  promotions,
  onPromotionClick,
}: Readonly<PromotionGalleryProps>) {
  const chunks = chunk(promotions, 4);

  const renderPromotion = (promotion: Promotion) => {
    const isBestSeller = !!promotion.isBestSeller;
    const isDiscount = (promotion.discountPercentage ?? 0) > 0;

    const badges: { label: string; bgColor: string }[] = [];

    if (isBestSeller) {
      badges.push({ label: 'BEST SELLER', bgColor: 'bg-success' });
    }

    if (isDiscount) {
      badges.push({
        label: `${promotion.discountPercentage}% Discount`,
        bgColor: 'bg-red-500',
      });
    }

    return (
      <button
        key={promotion.country.id}
        onClick={() => onPromotionClick(promotion.country.id)}
        className='flex-shrink-0 w-[calc((100vw-326px-72px)/4)] min-w-[260px] relative flex items-start space-x-3 px-2 py-6 rounded-xl cursor-pointer bg-wl-background text-wl-on-background'
      >
        <BadgeGroup badges={badges} />
        <Flag flagSrc={promotion.country.flag} />
        <div className='flex flex-col'>
          <span className='text-sm font-medium'>{promotion.country.name}</span>
        </div>
      </button>
    );
  };

  return (
    <div className='w-full mb-4'>
      <div className='md:hidden'>
        <div
          className='overflow-x-auto promotion-grid'
          role='region'
          aria-label='Scrollable promotion gallery'
        >
          {promotions.map(renderPromotion)}
        </div>
      </div>

      <div className='hidden md:block'>
        <div className='flex flex-col gap-6 overflow-x-auto'>
          {chunks.map((chunk, index) => (
            <div
              key={index}
              role='region'
              aria-label={`Promotion row ${index + 1} of ${chunks.length}`}
              className='flex gap-6 overflow-x-auto min-w-fit justify-start'
            >
              {chunk.map(renderPromotion)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
